import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  imports: [],
})
export class LinkComponent implements OnInit {
  @Input() color: string = 'primary';
  @Input() weight: string = 'bold';

  @Output() linkClick = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {
    console.log('TODO');
  }

  clickEmit() {
    this.linkClick.emit();
  }

  getClass() {
    return this.weight ? 'fw-' + this.weight : '';
  }
}
